/**
 * User: hella
 * Date: 4/6/14
 * Time: 1:15 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#baseDomain
 * js/global/core/dibs.js#parseUri
 * js/global/core/dibs.js#URL
 * dibs.baseDomain
 * dibs.parseUri
 * dibs.URL
 */
'use strict';

const bunsenUri = require('bunsen/helpers/uri');
const deprecationNotice = '[.com] global/utils/commonjs/uri module has been deprecated.';

/* develblock:start */
console.warn(`${deprecationNotice} use bunsen/helpers/uri module`);
/* develblock:end */

exports.parseUri = function parseUri(str, mode) {
    let parseOptions = {};
    /* develblock:start */
    console.warn(`${deprecationNotice} use bunsen/helpers/uri module`);
    /* develblock:end */

    if (typeof mode === 'string') {
        /* develblock:start */
        console.warn('`mode` argument was passed in as a string. please udpate this to `{ mode: mode }`');
        /* develblock:end */
        parseOptions.mode = mode;
    } else if (typeof mode === 'object' && !Array.isArray(mode)) {
        parseOptions = mode;
    }
    //console.log("str: ", str);
    return bunsenUri.parseUri(str, parseOptions);
};

// make the parsed URL of the current page available on the global dibs namespace
// handy to have around
exports.URL = bunsenUri.URL;



// WEBPACK FOOTER //
// ./assets/js/global/utils/commonjs/uri.es.js